import * as React from "react";
import { Component, Fragment } from "react";
import PredictionResultsTable from "../../tables/PredictionResultsTable";
// import clRankings from "../../../fake-data/clRankings";
import Card from "react-md/lib/Cards/Card";
import CardTitle from "react-md/lib/Cards/CardTitle";
import CardText from "react-md/lib/Cards/CardText";
import MenuButton from "react-md/lib/Menus/MenuButton";
import ListItem from "react-md/lib/Lists/ListItem";
import getFromApi from "src/services/fetchService";

interface ITournamentRankingsState extends ITournamentRankings {
  selectedTourIndex: number;
  isLoaded: boolean;
}

class TournamentRankings extends Component<{}, ITournamentRankingsState> {
  constructor(props: {}) {
    super(props);

    this.state = {
      tournamentTitle: "",
      tourResults: [],
      selectedTourIndex: 0,
      isLoaded: false
    };
  }

  async componentDidMount() {
    this.setState({ tournamentTitle: "Лига Чемпионов 2019-2020" });

    let expertStats: ITourResult[] = await getFromApi<ITourResult[]>(
      "https://football-predictions-v2.herokuapp.com/api/tournaments/2/expert-stats"
    );
    // tslint:disable-next-line:no-console
    console.log(expertStats);

    let sumResult = await this.constructExpertSumResult(expertStats);
    let sumTourResult = {
      tourNumber: "За все туры",
      expertStatsInTour: sumResult
    };
    expertStats.unshift(sumTourResult);

    this.setState({ tourResults: expertStats });
    this.setState({ isLoaded: true});
  }

  constructExpertSumResult = async (expertStats: ITourResult[]) => {
    // let apiData: ITourResult[] = await getFromApi<ITourResult[]>(
    //   "https://football-predictions-v2.herokuapp.com/api/headtohead/tournaments/1/table"
    // );
    // // tslint:disable-next-line:no-console
    // console.log(apiData);

    let tourResults = expertStats;

    // let tourResults = clRankings;
    let expertMap = new Map<number, IExpertResult>();

    tourResults.forEach((tourResult, i) => {
      let expertResults = tourResult.expertStatsInTour;
      expertResults.forEach((expertResult, j) => {
        let id = expertResult.expertId;

        let oldSumResult = expertMap.get(id);
        if (oldSumResult !== undefined) {
          let newSumResult = {
            expertId: oldSumResult.expertId,
            nickname: oldSumResult.nickname,
            outcomes: oldSumResult.outcomes + expertResult.outcomes,
            differences: oldSumResult.differences + expertResult.differences,
            scores: oldSumResult.scores + expertResult.scores,
            sum: oldSumResult.sum + expertResult.sum
          };
          expertMap.set(id, newSumResult);
        } else {
          expertMap.set(id, expertResult);
        }
      });
    });

    return Array.from(expertMap.values()).sort(
      (res1, res2) => res2.sum - res1.sum
    );
  }

  constructMenuItems = () => {
    let items = this.state.tourResults.map((item, i) => (
      <ListItem
        key={i}
        primaryText={item.tourNumber}
        onClick={() => this.onMenuItemClick(i)}
      />
    ));
    // items = items.concat(this.state.tourResults.map(tr => tr.tourTitle));
    return items;
  }

  constructHeader = () => {
    if (!this.state.tournamentTitle) {
      return "";
    }

    let tournamentTitle = this.state.tournamentTitle;
    let tourIndex = this.state.selectedTourIndex;

    if (tourIndex > 0) {
      return `${tournamentTitle}, тур ${tourIndex}`;
    } else {
      return tournamentTitle;
    }
  }

  onMenuItemClick = (index: number) => {
    this.setState({ selectedTourIndex: index });
  }

  renderContent() {
    if (this.state.isLoaded) {
      return (
        <Card>
        <CardTitle title={this.constructHeader()} />
        <CardText>
          <MenuButton
            raised
            primary
            menuItems={this.constructMenuItems()}
            simplifiedMenu={false}
            listHeightRestricted={false}
          >
            {"Выбрать тур"}
          </MenuButton>
          {this.state.tourResults.length > 0 && (
            <PredictionResultsTable
              expertResults={
                this.state.tourResults[this.state.selectedTourIndex]
                  .expertStatsInTour
              }
              // expertResults={this.constructExpertSumResult()}
            />
          )}
        </CardText>
      </Card>
      );
    } else {
      return (
        <Card>
          <CardTitle title="Получение данных..." />
        </Card>
      );
    }
  }

  render() {
    return (
      // <Fragment>
      //   <Card>
      //     <CardTitle title={this.constructHeader()} />
      //     <CardText>
      //       <MenuButton
      //         raised
      //         primary
      //         menuItems={this.constructMenuItems()}
      //         simplifiedMenu={false}
      //         listHeightRestricted={false}
      //       >
      //         {"Выбрать тур"}
      //       </MenuButton>
      //       {this.state.tourResults.length > 0 && (
      //         <PredictionResultsTable
      //           expertResults={
      //             this.state.tourResults[this.state.selectedTourIndex]
      //               .expertStatsInTour
      //           }
      //           // expertResults={this.constructExpertSumResult()}
      //         />
      //       )}
      //     </CardText>
      //   </Card>
      // </Fragment>
      <Fragment>{this.renderContent()}</Fragment>
    );
  }
}

export default TournamentRankings;



// WEBPACK FOOTER //
// ./src/components/pages/tournament-rankings/TournamentRankings.tsx